import { Component, Input } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  template: `
    <div *nzModalTitle>
      <span
        nz-icon
        nzTheme="outline"
        style="float: right; margin-left: 16px; font-size: 22px; color: red;"
      ></span>
      <span>עריכה</span>
    </div>
    <div>
      <input nz-input placeholder="טקסט חדש.." [(ngModel)]="text" />
    </div>
    <div *nzModalFooter>
      <button
        nz-button
        nzType="primary"
        nzDanger
        (click)="ok()"
        [disabled]="disabled"
      >
        אישור
      </button>
      <button nz-button nzType="default" (click)="cancel()">ביטול</button>
    </div>
  `
})
export class NzModalEditTextComponent {
  @Input() text?: string;

  get disabled(): boolean {
    return !this.text;
  }

  constructor(private modal: NzModalRef) {}

  ok(): void {
    this.modal.triggerOk();
  }

  cancel(): void {
    this.modal.triggerCancel();
  }
}
